export const notificationsSelector = {
  all_object: (state) => state.notifications,
  list: (state) => state.notifications.list ?? [],
};
